import SelectorModulos from '../SelectorModulos';

export const submodulosSchema = {
  fields: [
    {
      name: 'idmodulos',
      type: 'custom',
      component: SelectorModulos,
      label: 'Módulo Padre',
      required: true,
      gridSpan: 'full'  // Cambiar a full para que ocupe todo el ancho
    },
    {
      name: 'codigo',
      type: 'text',
      label: 'Código del Submódulo',
      required: true,
      placeholder: 'ej: CLIENTES',
      gridSpan: 'auto',
      format: 'uppercase'
    },
    {
      name: 'nombre',
      type: 'text', 
      label: 'Nombre del Submódulo',
      required: true,
      placeholder: 'ej: Gestión de Clientes',
      gridSpan: 'auto'
    },
    {
      name: 'icono',
      type: 'text',
      label: 'Icono',
      required: true,
      placeholder: 'ej: users, settings, folder, default circle',
      gridSpan: 'auto',
      defaultValue: 'circle'
    },
    {
      name: 'componente_form',
      type: 'text',
      label: 'Componente Form',
      required: true,
      placeholder: 'ej: cxc/CatalogoClientesForm, default EnConstruccion',
      gridSpan: 'auto',
      defaultValue: 'EnConstruccion'
    },
    {
      name: 'escatalogo',
      type: 'checkbox',
      label: 'Es Catalogo',
      required: false,
      gridSpan: 'full'
    },
    {
      name: 'descripcion',
      type: 'textarea',
      label: 'Descripción',
      required: true,
      placeholder: 'ej: Módulo para gestionar información de clientes',
      gridSpan: 'full'
    },
    {
      name: 'activo',
      type: 'checkbox',
      label: 'Submódulo activo',
      required: false,
      gridSpan: 'full'
    }
  ]
};